"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var Page = function (_a) {
    var children = _a.children, isHidden = _a.isHidden, className = _a.className, onClick = _a.onClick, isCurrent = _a.isCurrent;
    if (isHidden)
        return null;
    var classNames = (className || '') + " " + (isCurrent && 'current');
    return react_1.default.createElement(styles_1.default, { className: classNames, onClick: onClick.bind(undefined, children) }, children);
};
exports.default = Page;
//# sourceMappingURL=index.js.map